import AzureExtractFeed from './AzureExtractFeed'

export default function EgmFeed() {
  return <AzureExtractFeed feedId="egm" />
}
